import {
    REPORTS_TUTOR_EXAM_SCHEDULE_IS_LOADING,
    REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_SUCCESS,
    REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_ERROR,
  } from "../actions/action_types";
  
  export default function tutorExamScheduleReducer(
    state = { tutorExamScheduleData: {}, isTutorExamSchduleLoading: false, reportTutorExamSchduleError: null },
    action
  ) {
    switch (action.type) {
      case REPORTS_TUTOR_EXAM_SCHEDULE_IS_LOADING:
        return { ...state, isTutorExamSchduleLoading: true };
      case REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_SUCCESS:
        return { ...state, tutorExamScheduleData: action.payload, isTutorExamSchduleLoading: false };
      case REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_ERROR:
        return { ...state, reportTutorExamSchduleError: action.payload, isTutorExamSchduleLoading: false };
      default:
        return state;
    }
  }
  